export default __webpack_public_path__ + "static/media/roboto-v20-latin-100.ce83c72a.ttf";